import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import { ConfigProvider } from "./context/ConfigContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BottomNav from "./components/BottomNav";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Categories from "./pages/Categories";
import ProductDetail from "./pages/ProductDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SellerDashboard from "./pages/SellerDashboard";
import Account from "./pages/Account";
import Live from "./pages/Live";
import LiveDetail from "./pages/LiveDetail";
import Suppliers from "./pages/Suppliers";
import Help from "./pages/Help";
import Legal from "./pages/Legal";
import About from "./pages/About";
import Cart from "./pages/Cart";
import Storefront from "./pages/Storefront";
import OrderDetail from "./pages/OrderDetail";
import Auctions from "./pages/Auctions";
import AuctionDetail from "./pages/AuctionDetail";
import Settings from "./pages/Settings";
import AccountOrders from "./pages/account/Orders";
import Favorites from "./pages/account/Favorites";
import History from "./pages/account/History";
import Addresses from "./pages/account/Addresses";
import Quotes from "./pages/account/Quotes";
import Messages from "./pages/account/Messages";
import Messenger from "./pages/Messenger";
import SmoothScroll from "./components/SmoothScroll";
import AiAssistant from "./components/AiAssistant";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <LangProvider>
          <ConfigProvider>
            <AuthProvider>
            <CurrencyProvider>
              <CartProvider>
                <ScrollToTop />
                <SmoothScroll />
                <Navbar />
                <main className="flex-1 pb-20 md:pb-0">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/seller" element={<SellerDashboard />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/live" element={<Live />} />
                    <Route path="/live/:id" element={<LiveDetail />} />
                    <Route path="/suppliers" element={<Suppliers />} />
                    <Route path="/store/:slug" element={<Storefront />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/orders/:id" element={<OrderDetail />} />
                    <Route path="/auctions" element={<Auctions />} />
                    <Route path="/auctions/:id" element={<AuctionDetail />} />
                    <Route path="/account/settings" element={<Settings />} />
                    <Route path="/account/orders" element={<AccountOrders />} />
                    <Route path="/account/favorites" element={<Favorites />} />
                    <Route path="/account/history" element={<History />} />
                    <Route path="/account/addresses" element={<Addresses />} />
                    <Route path="/account/quotes" element={<Quotes />} />
                    <Route path="/account/messages" element={<Messages />} />
                    <Route path="/messages" element={<Messenger />} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/legal" element={<Legal />} />
                    <Route path="/about" element={<About />} />
                  </Routes>
                </main>
                <Footer />
                <BottomNav />
                <AiAssistant />
              </CartProvider>
            </CurrencyProvider>
            </AuthProvider>
          </ConfigProvider>
        </LangProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
